// extracted by mini-css-extract-plugin
export var content = "page-module--content--PuPFT";
export var header = "page-module--header--bzX7V";
export var header__content = "page-module--header__content--OPYco";
export var share = "page-module--share--DXrDu";
export var tag = "page-module--tag--ND+fS";
export var tags = "page-module--tags--yGt-n";
export var video = "page-module--video--nMPGB";